<template>
  <div class="row pb-4">
    <div class="col-12">
      <div class="form-group">
        <label>Summary</label>
        <HtmlEditor
          v-model="draft.summary"
          class="d-none d-md-block"
          :class="{
            'is-invalid': false,
          }"
          :enable-charts="true"
          :image-upload-url="imageUploadUrl"
          :file-upload-url="fileUploadUrl"
        />
      </div>

      <div class="form-group">
        <label>FX Regime</label>
        <HtmlEditor
          v-model="draft.fxRegime"
          class="d-none d-md-block"
          :class="{
            'is-invalid': false,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {Vue, Component, Prop, Emit} from 'nuxt-property-decorator'
import { HtmlEditor } from '@frontend/components'
import Autocomplete from '@/components/Autocomplete'

@Component({
  components: {
    Autocomplete,
    HtmlEditor,
  }
})
export default class CountriesListView extends Vue {
  @Prop({default: false, type: Boolean}) loading
  @Prop({default: ()=> {}, type: Object}) draft

  error = null
  imageUploadUrl = process.env.VUE_APP_API_ENDPOINT + 'upload/image'
  fileUploadUrl = process.env.VUE_APP_API_ENDPOINT + 'upload/file'

  @Emit()
  save() {
    return this.draft
  }

  @Emit()
  cancel() {}

  @Emit()
  publish() {
    return this.draft
  }
}
</script>
